import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { tap } from "rxjs/operators";
import { SystemAccountAuthModel } from "../models/system-account";
import {JwtHelperService} from "@auth0/angular-jwt"

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  static tokenName: string = "incucai_token";
    constructor(private router: Router) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request to add the new header.
    const authReq = req.clone({
      headers: req.headers
        .set(
          "Authorization",
          `Bearer ${localStorage.getItem(AuthInterceptor.tokenName)}`
        )
            .set("IW", `${localStorage.getItem("iw")}`),
    });
      

    try {
      //send the newly created request
      return next.handle(authReq).pipe(
          tap(
            (event) => {
                  if (event instanceof HttpResponse) {
                      if (!!localStorage.getItem("iw")) {
                          if (isUserByOrganizationIdNull())
                              this.router.navigate(['login/:userByOrganization'], { queryParams: { userByOrganization: -1, fromDetail: true }, skipLocationChange: true });

                      }
            }

          },
          (err) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                // handle error
                this.router.navigate(["/login"]);
              }
            }
          }
        )
      );
    } catch (err) {
      // onError
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          //window.location.href = "/login";
          this.router.navigate(["/login"]);
        }
      }
      }

      function isUserByOrganizationIdNull() {
          const token = localStorage.getItem("incucai_token");
          const jwtHelper: JwtHelperService = new JwtHelperService();
          var userByOrganizationId = JSON.stringify(jwtHelper.decodeToken(token));
          if(userByOrganizationId.includes("userByOrganizationId"))
          {

            var data = JSON.parse(userByOrganizationId);
            if (data.userByOrganizationId == null || data.userByOrganizationId == "")
          {

            return true;
          }

          }
          return false;

      }
  }
}
